import dayjs from 'dayjs/esm';

export interface ICbicMenuMst {
  id?: number;
  isActive?: string | null;
  orderId?: number | null;
  createdDt?: dayjs.Dayjs | null;
  updatedDt?: dayjs.Dayjs | null;
  createdBy?: number | null;
  updatedBy?: number | null;
  menuIcon?: string | null;
  menuName?: string | null;
  path?: string | null;
  menuDescription?: string | null;
  menuInput?: string | null;
  parentMenuId?: number | null;
  menuType?: string | null;
}

export class CbicMenuMst implements ICbicMenuMst {
  constructor(
    public id?: number,
    public isActive?: string | null,
    public orderId?: number | null,
    public createdDt?: dayjs.Dayjs | null,
    public updatedDt?: dayjs.Dayjs | null,
    public createdBy?: number | null,
    public updatedBy?: number | null,
    public menuIcon?: string | null,
    public menuName?: string | null,
    public path?: string | null,
    public menuDescription?: string | null,
    public menuInput?: string | null,
    public parentMenuId?: number | null,
    public menuType?: string | null
  ) {}
}

export function getCbicMenuMstIdentifier(cbicMenuMst: ICbicMenuMst): number | undefined {
  return cbicMenuMst.id;
}
